import {getWarmingUpStatus} from '@/api/warmingUpApi';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventLicenseService} from '@/constants/pubSubEnum';
import {eventBusObject} from '@/observers/eventBus';

// eslint-disable-next-line import/prefer-default-export
export const onWarmingUpStatus = async () => {
  try {
    const response = await getWarmingUpStatus();
    const _bus = eventBusObject();
    console.log({response});
    const status = response.data.Status;

    if (status === 'WarmingUp') {
      window.location.href = APPDATA.WARMING_UP_ADRESS;
      return true;
    }

    // Move checking version on LicenseService files
    // if (APPDATA.CONFIGURATION.ENABLED_UPDATE_SOFTWARE) {
    //     console.log('enabled updatess ', self, response, this.props)
    //     this._bus.publish(EventCheckUpdateSystem.CheckingVersionUpdate, { IsFromHome: true });
    // }
    _bus.publish(EventLicenseService.initialLicenseService, {isShowTrialModal: true});
    return true;
  } catch (error) {
    console.error(error);
    return true;
  }
};
